import { useEffect, useState } from 'react';
import api from '../api';

// Serial number (Connect `reference`) per device id, fetched one device at a time and
// only for the ids asked for -- the rows on screen -- so a customer with many held
// gateways costs a handful of requests, not one per device, until "See all" is opened.
const useDeviceSerials = deviceIds => {
    const [serials, setSerials] = useState({});
    const key = deviceIds.join(',');

    useEffect(() => {
        const missing = key ? key.split(',').filter(id => !(id in serials)) : [];
        if (!missing.length) {
            return undefined;
        }
        let active = true;
        Promise.allSettled(missing.map(id => api.get_device_info(id))).then(results => {
            if (!active) {
                return;
            }
            setSerials(previous => {
                const next = { ...previous };
                results.forEach((result, i) => {
                    next[missing[i]] = result.status === 'fulfilled' ? result.value?.data?.reference || null : null;
                });
                return next;
            });
        });
        return () => {
            active = false;
        };
        // `serials` is read only to skip ids already fetched; re-running on it would loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);

    return serials;
};

export default useDeviceSerials;
